import { Routes, Route } from "react-router-dom";
import { PTLI0701001Q } from "@/tra/tancis/ptli/elctdoc/rcpn/PTLI0701001Q";
import { PTLI0701002Q } from "@/tra/tancis/ptli/elctdoc/rcpn/PTLI0701002Q";
import { PTLI0702001Q } from "@/tra/tancis/ptli/elctdoc/trmssn/PTLI0702001Q";
import { PTLI0702002S } from "@/tra/tancis/ptli/elctdoc/trmssn/PTLI0702002S";
import { PTLI0702003Q } from "@/tra/tancis/ptli/elctdoc/trmssn/PTLI0702003Q";
import { PTLI0703001Q } from "@/tra/tancis/ptli/elctdoc/box/PTLI0703001Q";
import { PTLI0703002S } from "@/tra/tancis/ptli/elctdoc/box/PTLI0703002S";
import { PTLI0703003S } from "@/tra/tancis/ptli/elctdoc/box/PTLI0703003S";
import { PTLI0704001Q } from "@/tra/tancis/ptli/elctdoc/ucr/PTLI0704001Q";
import { PTLI0704002S } from "@/tra/tancis/ptli/elctdoc/ucr/PTLI0704002S";
import { PTLI0705001Q } from "@/tra/tancis/ptli/elctdoc/chnl/PTLI0705001Q";
import { PTLI0705002S } from "@/tra/tancis/ptli/elctdoc/chnl/PTLI0705002S";
import { PTLI0705003S } from "@/tra/tancis/ptli/elctdoc/chnl/PTLI0705003S";
import { PTLI0706001Q } from "@/tra/tancis/ptli/elctdoc/gway/PTLI0706001Q";
import { PTLI0706002S } from "@/tra/tancis/ptli/elctdoc/gway/PTLI0706002S";
import { PTLI0706003S } from "@/tra/tancis/ptli/elctdoc/gway/PTLI0706003S";
import { PTLI0707001Q } from "@/tra/tancis/ptli/elctdoc/hist/PTLI0707001Q";
import { PTLI0707002Q } from "@/tra/tancis/ptli/elctdoc/hist/PTLI0707002Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const ElctdocRouter = () => {
    return (
        <Routes>
            <Route path={"/rcpn/ptli0701001q"} element={<PTLI0701001Q />} />
            <Route path={"/rcpn/ptli0701002q/:trscLogId"} element={<PTLI0701002Q />} />

            <Route path={"/trmssn/ptli0702001q"} element={<PTLI0702001Q />} />
            <Route path={"/trmssn/ptli0702002s/:docNtcUuid"} element={<PTLI0702002S />} />
            <Route path={"/trmssn/ptli0702003q/:trscLogId"} element={<PTLI0702003Q />} />

            <Route path={"/box/ptli0703001q"} element={<PTLI0703001Q />} />
            <Route path={"/box/ptli0703002s/:intfId"} element={<PTLI0703002S />} />
            <Route path={"/box/ptli0703003s"} element={<PTLI0703003S />} />

            <Route path={"/ucr/ptli0704001q"} element={<PTLI0704001Q />} />
            <Route path={"/ucr/ptli0704002s/:fullUcrNo"} element={<PTLI0704002S />} />

            <Route path={"/chnl/ptli0705001q"} element={<PTLI0705001Q />} />
            <Route path={"/chnl/ptli0705002s"} element={<PTLI0705002S />} />
            <Route path={"/chnl/ptli0705003s/:intfChnlId"} element={<PTLI0705003S />} />

            <Route path={"/gway/ptli0706001q"} element={<PTLI0706001Q />} />
            <Route path={"/gway/ptli0706002s"} element={<PTLI0706002S />} />
            <Route path={"/gway/ptli0706003s/:gwayId"} element={<PTLI0706003S />} />

            <Route path={"/hist/ptli0707001q"} element={<PTLI0707001Q />} />
            <Route path={"/hist/ptli0707002q/:trscLogId"} element={<PTLI0707002Q />} />
        </Routes>
    );
};
